import 'svelte/internal/disclose-version';

LoadError[$.FILENAME] = 'src/ui/LoadError.svelte';

import * as $ from 'svelte/internal/client';
import { clockTime, describeError } from "./errors.ts";
import { Press, watchAlt } from "./keys.ts";

var root = $.add_locations($.from_html(`<kbd>Enter</kbd>`), LoadError[$.FILENAME], [[88, 17]]);
var root_1 = $.add_locations($.from_html(`<kbd>Esc</kbd>`), LoadError[$.FILENAME], [[93, 19]]);

var root_2 = $.add_locations(
	$.from_html(
		`
      <button type="button"> <!>
      </button>
    `,
		1
	),
	LoadError[$.FILENAME],
	[[91, 6]]
);

var root_3 = $.add_locations(
	$.from_html(
		`

<section class="failure svelte-1kr75s1ytb0fu" role="alert" aria-labelledby="failure-title">
  <h2 id="failure-title" class="svelte-1kr75s1ytb0fu"> </h2>
  <p class="detail svelte-1kr75s1ytb0fu"> </p>
  <p class="hint svelte-1kr75s1ytb0fu"> </p>
  <div class="actions svelte-1kr75s1ytb0fu">
    <!-- TODO: Accept assistive clicks with detail=0; prevent duplicates in the key handler instead. -->
    <button type="button">
      Retry
      <!>
    </button>
    <!>
    <span class="at svelte-1kr75s1ytb0fu"> </span>
  </div>
</section>

`,
		1
	),
	LoadError[$.FILENAME],
	[
		[
			73,
			0,
			[[74, 2], [75, 2], [76, 2], [77, 2, [[79, 4], [96, 4]]]]
		]
	]
);

export default function LoadError($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, LoadError);

	let busy = $.prop($$props, 'busy', 3, false),
		backLabel = $.prop($$props, 'backLabel', 3, "Back to sets");

	const text = $.tag($.derived(() => describeError($$props.error)), 'text');
	const time = $.tag($.derived(() => clockTime($$props.at)), 'time');
	let hints = $.tag($.state(false), 'hints');
	let pressed = $.tag($.state(null), 'pressed');
	let retry = $.tag($.state(void 0), 'retry');
	let back = $.tag($.state(void 0), 'back');
	const press = new Press();

	$.user_effect(() => watchAlt((held) => $.set(hints, held, true)));

	$.user_effect(() => {
		$.get(retry)?.focus();
	});

	function fire(action) {
		if ($.strict_equals(action, "back")) $$props.onback?.(); else if (!busy()) $$props.onretry();
	}

	$.user_effect(() => {
		const cancel = () => {
			press.cancel();
			$.set(pressed, null);
		};

		const down = (e) => {
			// TODO: Scope shortcuts to the error view instead of consuming keys in storybook controls.
			if (e.metaKey || e.ctrlKey || e.altKey) return;

			let action = null;

			if ($.strict_equals(e.key, "Escape") && $$props.onback) action = "back"; else if ($.strict_equals(e.key, "Enter") || $.strict_equals(e.key, " ")) action = $$props.onback && $.strict_equals(document.activeElement, $.get(back)) ? "back" : "retry"; else if ($.strict_equals(e.key, "r")) action = "retry";
			if (!action) return;

			e.preventDefault();

			if (press.down(e.key, e.repeat, action)) $.set(pressed, action, true);
		};

		const up = (e) => {
			const action = press.up(e.key);

			if (!action) return;

			e.preventDefault();
			$.set(pressed, null);
			fire(action);
		};

		addEventListener("keydown", down);
		addEventListener("keyup", up);
		addEventListener("blur", cancel);

		return () => {
			removeEventListener("keydown", down);
			removeEventListener("keyup", up);
			removeEventListener("blur", cancel);
		};
	});

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_3();
	var section = $.sibling($.first_child(fragment));
	var h2 = $.sibling($.child(section));
	var text_1 = $.only_child(h2, true);
	var p = $.sibling(h2, 2);
	var text_2 = $.only_child(p, true);
	var p_1 = $.sibling(p, 2);
	var text_3 = $.only_child(p_1, true);
	var div = $.sibling(p_1, 2);
	var node = $.sibling($.child(div));
	var button = $.sibling(node, 2);
	let classes;
	var node_1 = $.sibling($.child(button));

	{
		var consequent = ($$anchor) => {
			var kbd = root();

			$.append($$anchor, kbd);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if ($.get(hints)) $$render(consequent);
			}),
			'if',
			LoadError,
			88,
			6
		);
	}

	$.next();
	$.reset(button);
	$.bind_this(button, ($$value) => $.set(retry, $$value), () => $.get(retry));

	var node_2 = $.sibling(button, 2);

	{
		var consequent_2 = ($$anchor) => {
			var fragment_1 = root_2();
			var button_1 = $.sibling($.first_child(fragment_1));
			let classes_1;
			var text_4 = $.child(button_1);
			var node_3 = $.sibling(text_4);

			{
				var consequent_1 = ($$anchor) => {
					var kbd_1 = root_1();

					$.append($$anchor, kbd_1);
				};

				$.add_svelte_meta(
					() => $.if(node_3, ($$render) => {
						if ($.get(hints)) $$render(consequent_1);
					}),
					'if',
					LoadError,
					93,
					8
				);
			}

			$.next();
			$.reset(button_1);
			$.bind_this(button_1, ($$value) => $.set(back, $$value), () => $.get(back));
			$.next();

			$.template_effect(() => {
				classes_1 = $.set_class(button_1, 1, 'svelte-1kr75s1ytb0fu', null, classes_1, { pressed: $.strict_equals($.get(pressed), "back") });

				$.set_text(text_4, `
        ${backLabel() ?? ''}
        `);
			});

			$.delegated('click', button_1, function click_1(e) {
				return $.strict_equals(e.detail, 0, false) && fire("back");
			});

			$.append($$anchor, fragment_1);
		};

		$.add_svelte_meta(
			() => $.if(node_2, ($$render) => {
				if ($$props.onback) $$render(consequent_2);
			}),
			'if',
			LoadError,
			90,
			4
		);
	}

	var span = $.sibling(node_2, 2);
	var text_5 = $.only_child(span);

	$.next();
	$.reset(div);
	$.next();
	$.reset(section);
	$.next();

	$.template_effect(() => {
		$.set_text(text_1, $$props.title);
		$.set_text(text_2, $.get(text).detail);
		$.set_text(text_3, $.get(text).hint);
		$.set_attribute(button, 'aria-disabled', busy() ? "true" : undefined);
		$.set_attribute(button, 'aria-busy', busy() ? "true" : undefined);
		classes = $.set_class(button, 1, 'svelte-1kr75s1ytb0fu', null, classes, { pressed: $.strict_equals($.get(pressed), "retry") });
		$.set_text(text_5, `Last tried ${$.get(time) ?? ''}`);
	});

	$.delegated('click', button, function click(e) {
		return $.strict_equals(e.detail, 0, false) && fire("retry");
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click']);
import "bun-svelte:LoadError.svelte-2jkneydiukw0v-style.css";